import React, { useEffect, useState } from 'react';
import globalSettingsStores from '../../../../stores/settings-stores';
import externalExamGroupsStore from '../../../../stores/external-exam-groups-store';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { ExternalExamGroup } from '../../../../api/types/external-exams/external-exam-group';
import dateUtils from '../../../../utils/date-format';
import { observer } from 'mobx-react-lite';
import { DeleteGroupConfirmDialog } from './components/delete-group-confirm-dialog';
import { GroupDetailsDialog } from './dialogs/group-details-dialog/group-details-dialog';
import { AddEditGroupDialog } from './dialogs/add-edit-group-dialog';
import { getHebrewYear } from '../../../../utils/hebrew-date-utils';

export const ExternalExamGroupsTab = observer(() => {
  const [deleteGroup, setDeleteGroup] = useState<ExternalExamGroup | null>(
    null,
  );
  const [selectedGroup, setSelectedGroup] = useState<ExternalExamGroup | null>(
    null,
  );
  const [addEditGroup, setAddEditGroup] = useState<ExternalExamGroup | null>(
    null,
  );
  const [showAddEditDialog, setShowAddEditDialog] = useState(false);
  const [deleteGroupId, setDeleteGroupId] = useState<number | null>(null);

  useEffect(() => {
    externalExamGroupsStore.fetchGroups();
  }, []);

  return (
    <div>
      <Button
        onClick={() => {
          setAddEditGroup(null);
          setShowAddEditDialog(true);
        }}
        style={{ height: '30px', marginBottom: '16px' }}
        label={'הוספת מקבץ'}
      />
      <DataTable
        emptyMessage={<div style={{ textAlign: 'right' }}>לא נמצאו מקבצים</div>}
        value={externalExamGroupsStore.groups}
        dataKey="id"
        tableStyle={{
          direction: 'rtl',
          marginTop: '16px',
        }}
        onRowClick={(e) => setSelectedGroup(e.data as ExternalExamGroup)}
        selectionMode="single"
        selection={selectedGroup}
        onSelectionChange={(e) => setSelectedGroup(e.value)}
      >
        <Column
          style={{ textAlign: 'right' }}
          field="groupName"
          header="שם מקבץ"
        />
        <Column
          style={{ textAlign: 'right' }}
          header="שנה"
          body={(rowData: ExternalExamGroup) => (
            <div>
              {rowData.year} ({getHebrewYear(rowData.year)})
            </div>
          )}
        />
        <Column
          style={{ textAlign: 'right' }}
          header="מספר מבחנים"
          body={(rowData: ExternalExamGroup) => (
            <div>{rowData.exams.length}</div>
          )}
        />
        <Column
          style={{ textAlign: 'right' }}
          field="createdByName"
          header="נוצר ע״י"
        />
        <Column
          style={{ textAlign: 'right' }}
          field="createdAt"
          header="נוצר בתאריך"
          body={(rowData: ExternalExamGroup) => (
            <div>{dateUtils.displayFormatDate(rowData.createdAt)}</div>
          )}
        />
        <Column
          style={{ textAlign: 'right' }}
          header="פעולות"
          body={(data: ExternalExamGroup) => (
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <Button
                icon="pi pi-pencil"
                text
                severity="warning"
                tooltip={'עריכת מקבץ'}
                onClick={(e) => {
                  e.stopPropagation();
                  setAddEditGroup(data);
                  setShowAddEditDialog(true);
                }}
              />
              <Button
                icon="pi pi-trash"
                text
                severity="danger"
                tooltip={'מחיקת מקבץ'}
                loading={deleteGroupId === data.id}
                disabled={deleteGroupId !== null}
                onClick={(e) => {
                  e.stopPropagation();
                  setDeleteGroup(data);
                }}
              />
            </div>
          )}
        />
      </DataTable>

      {deleteGroup && (
        <DeleteGroupConfirmDialog
          group={deleteGroup}
          visible={true}
          onHide={() => setDeleteGroup(null)}
        />
      )}

      {selectedGroup && (
        <GroupDetailsDialog
          group={selectedGroup}
          visible={true}
          onHide={() => setSelectedGroup(null)}
          onGroupUpdate={(updatedGroup) => setSelectedGroup(updatedGroup)}
        />
      )}

      {showAddEditDialog && (
        <AddEditGroupDialog
          group={addEditGroup}
          visible={showAddEditDialog}
          onHide={() => {
            setShowAddEditDialog(false);
            setAddEditGroup(null);
          }}
        />
      )}
    </div>
  );
});
